<template>
  <card class="account-setting-button">
    <div class="loading-content" v-if="loading">
      <tiny-loader :variant="'secondary-black'" />
    </div>
    <div class="button-content" v-on:click="action" v-else>
      <span class="account-setting-title" :class="color">{{ title }}</span>
      <span :class="`button-icon fa ${icon} ${computedIconColor}`"></span>
    </div>
  </card>
</template>

<script>

import BaseUI from 'base-ui';

export default {
  name: 'AccountSettingButton',
  components: {
    Card: BaseUI.Card,
    TinyLoader: BaseUI.TinyLoader,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    action: {
      type: Function,
      required: true,
    },
    color: {
      type: String,
      default: 'black',
    },
    icon: {
      type: String,
      default: 'fa-chevron-left',
    },
    iconColor: {
      type: String,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    computedIconColor() {
      return this.iconColor || this.color;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~base-ui/src/scss/riseup-colors";

  .account-setting-button {
    height: 64px;
    margin-top: 16px;
    background-color: $riseup_white;

    .loading-content {
      width: 100%;
      height: 100%;
      display: inline-flex;
      justify-content: center;
      align-items: center;
    }

    .button-content {
      width: 100%;
      height: 100%;
      display: inline-flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;

      .account-setting-title {
        font-size: 16px;
        font-weight: bold;

        &.red {
          color: $riseup_danger_red;
        }

        &.blue {
          color: $riseup_blue;
        }

        &.green {
          color: $riseup_green;
        }
      }

      .button-icon {
        &.red {
          color: $riseup_danger_red;
        }

        &.blue {
          color: $riseup_blue;
        }

        &.green {
          color: $riseup_green;
        }
      }
    }
  }
</style>
